import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import React, { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import { validationSchema } from "./Schemas/validation";
import { ModalContext } from "context/ModalContext";
import PropTypes from "prop-types";
import { LoginFormContext } from "context/LoginFormContext";
import SubmitButton from "components/SubmitButton";
import { statusData } from "helpers/constant";
import TinyTextEditor from "components/MDTinyTextEditor";
import { updateOccasion } from "Apis/occasion";
import { occasionAdd } from "Apis/occasion";
import MDSelectBox from "components/MDSelectBox";
import { OccasionContext } from "context/OccasionContext";
import SingleCheckbox from "components/MDCheckBox/MDSingleCheckBox";

const initialValues = {
  name: "",
  description: "",
  is_active: 0,
};

const OccasionForm = ({ getOccasionList }) => {
  const { editData } = useContext(OccasionContext);
  const { setNotification } = useContext(LoginFormContext);
  const { setOpen, formIsEdit } = useContext(ModalContext);
  const [isOnlineBooking, setIsOnlineBooking] = useState(1);

  useEffect(() => {
    const init = async () => {
      if (formIsEdit && editData) {
        formik?.setValues({
          id: editData?.id,
          name: editData?.name || "",
          description: editData?.description || "",
          is_active: String(editData?.is_active ?? ""),
          is_online_booking_available: String(editData?.is_online_booking_available ?? ""),
        });
        setIsOnlineBooking(editData?.is_online_booking_available ?? 1);
      }
    };
    init();
  }, []);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
    };

    if (!formIsEdit) {
      let response = await occasionAdd(payload);
      if (response?.status === 200) {
        getOccasionList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    } else {
      let response = await updateOccasion(payload);
      if (response?.status === 200) {
        getOccasionList();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response?.data?.message,
          open: true,
        });
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
      }
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleIsDefault = (e) => {
    setIsOnlineBooking(e?.target?.checked);
    formik.setFieldValue("is_online_booking_available", e?.target?.checked ? 1 : 0);
  };

  return (
    <MDBox component="form" role="form" onSubmit={formik?.handleSubmit}>
      <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {/* Name */}
        <Grid item xs={12} sx={{ paddingTop: "30px !important" }}>
          <MDInput
            type="text"
            name="name"
            required
            label="Occasion Name"
            variant="standard"
            value={formik?.values?.name}
            onChange={formik?.handleChange}
            onBlur={formik?.handleBlur}
            fullWidth
          />
          {formik?.touched?.name && formik?.errors?.name && (
            <MDBox sx={{ fontSize: "12px", color: "red", mt: "5px" }}>{formik?.errors?.name}</MDBox>
          )}
        </Grid>

        {/* Description */}
        <Grid item xs={12} sx={{ paddingTop: "30px !important" }}>
          <MDBox sx={{ fontSize: "16px", fontWeight: "400", mb: "5px", mt: "10px" }}>
            Description <span style={{ color: "red" }}>*</span>
          </MDBox>
          <TinyTextEditor
            setContent={(value) => formik?.setFieldValue("description", value)}
            content={formik?.values?.description}
            onBlur={formik?.handleBlur}
            folderName="/post"
          />
          {formik?.touched?.description && formik?.errors?.description && (
            <MDBox sx={{ fontSize: "12px", color: "red", mt: "5px" }}>
              {formik?.errors?.description}
            </MDBox>
          )}
        </Grid>
        <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
          <SingleCheckbox
            name="is_online_booking_available"
            label="This occasion is available for online booking"
            onChange={handleIsDefault}
            onBlur={formik?.handleBlur}
            checked={isOnlineBooking}
          />
        </Grid>
        {/* Status */}
        <Grid item xs={12} md={6} sx={{ paddingTop: "30px !important" }}>
          <MDSelectBox
            name="is_active"
            defaultValue={statusData?.find((s) => s?.value == formik?.values?.is_active) || null}
            options={statusData}
            handleChange={(value) => formik?.setFieldValue("is_active", value ? value?.value : "")}
            label="Status"
            width="100%"
            multiple={false}
            onBlur={formik?.handleBlur}
            required
          />
          {formik?.touched?.is_active && formik?.errors?.is_active && (
            <MDBox sx={{ fontSize: "12px", color: "red", mt: "5px" }}>
              {formik?.errors?.is_active}
            </MDBox>
          )}
        </Grid>
      </Grid>

      <MDBox sx={{ width: "100%", textAlign: "center", mt: 4 }}>
        <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
      </MDBox>
    </MDBox>
  );
};

OccasionForm.propTypes = {
  getOccasionList: PropTypes.func,
};

export default OccasionForm;
